import { applicationSettings } from '../application';
import { uniformGrid } from '../settingsHelpers';
import { DIMENSIONS, ITEMS, MS, TS, UNITS } from '../../constants';
const { width, depth, height } = DIMENSIONS;

export default {
  postWidth: 45,
  distanceBetweenAttachments: 32,
  grid: uniformGrid(1),
  defaultFilter: 'sections',
  roomMinDesktop: {
    width: 1000,
    height: 1000,
  },
  roomMinSummary: {
    width: 1000,
    height: 1000,
  },
  roomMinMobile: {
    width: 2200,
    height: 2200,
  },
  zoomableScene: false,
  sideWall: true,
  wall: {
    width: {
      min: 1000,
      max: 5700,
    },
    height: {
      min: 1000,
      max: 3250,
    },
    points:
      applicationSettings.uiPlatform === 'kiosk'
        ? [
            { x: 0, y: 0 },
            { x: 4600, y: 0 },
            { x: 4600, y: 2400 },
            { x: 0, y: 2400 },
          ]
        : [
            { x: 0, y: 0 },
            { x: 4000, y: 0 },
            { x: 4000, y: 2650 },
            { x: 0, y: 2650 },
          ],
    pointsMobilePortrait: [
      { x: 0, y: 0 },
      { x: 2400, y: 0 },
      { x: 2400, y: 2650 },
      { x: 0, y: 2650 },
    ],
    pointsMobileLandscape: [
      { x: 0, y: 0 },
      { x: 5700, y: 0 },
      { x: 5700, y: 2650 },
      { x: 0, y: 2650 },
    ],
    pointsTablet: [
      { x: 0, y: 0 },
      { x: 3900, y: 0 },
      { x: 3900, y: 2650 },
      { x: 0, y: 2650 },
    ],
  },
  canvasMargins: { top: 50, right: 50 },
  canvasMarginsKiosk: { top: 50, right: 50 },
  canvasMarginsMobile: {
    top: 50,
    right: 50,
  },
  canvasMarginsPortraitPercentual: {
    mobile: 0.075,
    tablet: 0.05,
  },
  sectionSnappingDistance: 50,
  showMultipleErrors: true,
  measurements: {
    productsRemap: [
      {
        affects: ['10453072'],
        keys: { 'system, width:': DIMENSIONS.width },
      },
    ],
    displayMeasurement: [
      {
        affects: [ITEMS.SECTION],
        rules: {
          display: true,
          measure: false,
          measurementPrefix: false,
          format: `${width}${TS}${height} ${MS}`,
          unit: UNITS.cm,
        },
      },
      {
        affects: [
          ITEMS.SHELF,
          ITEMS.FELT_SHELF,
          ITEMS.BOTTLE_RACK,
          ITEMS.DRAWER,
          ITEMS.ITEM,
          ITEMS.CHEST,
          ITEMS.CABINET,
          ITEMS.TABLE,
          ITEMS.SHELVING_UNIT,
          ITEMS.DOOR,
        ],
        rules: {
          measure: true,
          display: true,
          measurementPrefix: true,
          format: `${width} ${MS}, ${depth} ${MS}, ${height} ${MS}`,
          unit: UNITS.cm,
        },
      },
      {
        affects: [ITEMS.SHELF_DRAWER],
        rules: {
          measure: false,
          display: false,
          measurementPrefix: true,
          format: `${width} ${MS}, ${height} ${MS}, ${depth} ${MS}`,
          unit: UNITS.cm,
        },
      },
      {
        affects: [ITEMS.BOX],
        rules: {
          measure: false,
          display: true,
          measurementPrefix: true,
          format: `${width} ${MS}, ${depth} ${MS}, ${height} ${MS}`,
          unit: UNITS.cm,
        },
      },
    ],
  },
  hideInfoIconForType: [],
  bulkArticles: {},
  colorCodes: {
    pine: '#F4D8A8',
    mesh_white: '#F8F8F7',
    white: '#F8F8F7',
    grey: '#FBFBFB',
    mesh_green: '#3D6443',
    mesh_grey: '#736E6B',
    red: '#BA3531',
  },
};
